import { Link } from 'react-router-dom';
import { SCROLL_ALL_RESTAURANTS } from '../../homeScroll';
import './Footer.scss';

const MAP_QUERY =
  'Suite # 103 181 N Grant St Canby, OR 97013 US';

const TOP_CUISINES = [
  { label: 'American Cuisine', to: '/' },
  { label: 'Indian Cuisine', to: '/' },
  { label: 'Mexican Cuisine', to: '/' },
  { label: 'Chinese Cuisine', to: '/' },
  { label: 'Japanese Cuisine', to: '/' },
  { label: 'Columbian Cuisine', to: '/' },
];

export default function Footer() {
  const mapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAP_QUERY)}`;

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container site-footer__inner">
        <div className="site-footer__columns">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo" aria-label="DinDin home">
              <span className="site-footer__logo-text">DINDIN</span>
              <span className="site-footer__logo-plus" aria-hidden>
                +
              </span>
            </Link>
          </div>

          <nav className="site-footer__nav" aria-label="Top cuisines">
            <p className="site-footer__heading">Top Cuisines</p>
            <ul className="site-footer__list">
              {TOP_CUISINES.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="site-footer__link">
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/" state={SCROLL_ALL_RESTAURANTS} className="site-footer__link">
                  View All Cuisines
                </Link>
              </li>
            </ul>
          </nav>

          <nav className="site-footer__nav" aria-label="Contact and social">
            <p className="site-footer__heading">Say Hello</p>
            <ul className="site-footer__list">
              <li>
                <a
                  href="https://www.facebook.com/"
                  className="site-footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/"
                  className="site-footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href={mapHref}
                  className="site-footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Map
                </a>
              </li>
              <li>
                <a href="#contact-help" className="site-footer__link">
                  Need Help?
                </a>
              </li>
            </ul>
          </nav>

          <div className="site-footer__address-block">
            <p className="site-footer__heading">Address</p>
            <p className="site-footer__address">
              Suite # 103 181 N Grant St Canby, OR 97013 US
            </p>
          </div>
        </div>

        <div className="site-footer__bar" aria-label="Legal and credits">
          <span className="site-footer__bar-left">Powered by OMNITECH</span>
          <span className="site-footer__bar-center">
            © 2026 Omnitech LLC. All rights reserved.
          </span>
          <span className="site-footer__bar-right">
            <a href="#terms-of-service" className="site-footer__bar-link">
              Terms of Service
            </a>
            <span className="site-footer__bar-sep" aria-hidden />
            <a href="#privacy-policy" className="site-footer__bar-link">
              Privacy Policy
            </a>
            <span className="site-footer__bar-sep" aria-hidden />
            <a href="#manage-cookies" className="site-footer__bar-link">
              Manage Cookies
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
